import { ReactElement } from 'react';
import { Polyline } from 'react-leaflet';
import { LatLngExpression } from 'leaflet';
import { routeColor } from '../hooks/useRoutePaths';

/** Draw the viewed routes' paths, one colour per route (by list position). */
export default function RoutePolylines({
  routeIds,
  pathsById,
}: {
  routeIds: string[];
  pathsById: Map<string, LatLngExpression[]>;
}): ReactElement {
  return (
    <>
      {routeIds.map((routeId, idx) => {
        const path = pathsById.get(routeId);
        if (!path) return null;
        return (
          <Polyline
            key={routeId}
            positions={path}
            pathOptions={{ color: routeColor(idx), weight: 3, opacity: 0.8 }}
          />
        );
      })}
    </>
  );
}
